import { Box, Grid, styled, Typography } from '@mui/material'

interface HeaderProps {
    action?: React.ReactNode
}

const Header = ({ action }: HeaderProps) => {
    return (
        <RootStyled>
            <Grid container spacing={2}>
                <Grid item xl={7} lg={6} md={6} sm={12} xs={12}>
                    <TitleStyled>
                        Estado del pedido
                    </TitleStyled>
                </Grid>
                { action && (
                    <Grid 
                        item 
                        xl={5}
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        sx={(theme) => ({
                            [theme.breakpoints.down('md')]: {
                                display: 'none'
                            },
                        })}>
                            { action }
                    </Grid>
                )}
            </Grid>
        </RootStyled>
    )
}

const RootStyled = styled(Box)(({ theme }) => ({
    //marginBottom: theme.spacing(6)
}))

const TitleStyled = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    paddingTop: theme.spacing(.5),
    paddingBottom: theme.spacing(.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.grey[200],
    borderRadius: theme.spacing(.5),
    [theme.breakpoints.down('md')]: {
       height: theme.spacing(6),
       justifyContent: 'center'
    }
}))

export default Header
